// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';
import SettlementNoRegistrationDealerCriteria from '../../../../src/reports/settlement-no-registration/components/settlement-no-registration-dealer-criteria';

const SettlementNoRegistrationCriteria = props =>
    <div className='settlement-no-registration-criteria'>
        <div className='criteria'>
            <SettlementNoRegistrationDealerCriteria
                allowedAccounts={props.allowedAccounts}
                onDealerSelect={props.onDealerSelect}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedDealers={props.selectedDealers}
            />
            <LabeledCriteria
                className='history-to-display-criteria'
                isRequired={true}
                label='HISTORY_TO_DISPLAY'
                max='999'
                maxLength='3'
                min='1'
                onInputChange={props.onHistoryToDisplayChange}
                placeholder='ENTER_A_NUMBER_BETWEEN_0_AND_1000'
                type='number'
                value={props.historyToDisplay}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

SettlementNoRegistrationCriteria.displayName = 'SettlementNoRegistrationCriteria';
SettlementNoRegistrationCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    historyToDisplay: PropTypes.number,
    onCreateReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onHistoryToDisplayChange: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default SettlementNoRegistrationCriteria;



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/components/settlement-no-registration-report-criteria.js